import styles from "./index.module.scss";

const NavigationTabs = ({ tabs = [] }) => {
  return (
    <nav className={styles.nav} role="navigation" aria-label="Settings navigation">
      <div className={styles.navContainer}>
        {tabs.map((tab, index) => (
          <div key={index} className={styles.navTab}>
            <button
              className={`${styles.navButton} ${tab.disabled ? styles.navButtonDisabled : ''} ${tab.active ? styles.navButtonActive : ''}`}
              aria-current={tab.active ? "page" : undefined}
              disabled={tab.disabled}
              onClick={() => {
                tab?.onClick?.();
              }}
            >
              <span
                className={`${styles.navButtonText} ${
                  tab.active ? styles.active : tab.disabled ? styles.disabled : styles.inactive
                }`}
              >
                {tab.label}
              </span>
            </button>
          </div>
        ))}
      </div>
    </nav>
  );
};

export default NavigationTabs;

